var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabSlasherTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8698 0H12.1354C16.3737 0.0340145 19.3634 1.66679 21.2818 3.97662C23.1842 6.26734 24 9.1821 24 11.7617C24 13.9092 23.09 15.4073 21.9296 16.3883C20.8991 17.2594 19.685 17.7135 18.7595 17.89L17.0344 21.8355C16.915 22.1086 16.6409 22.2857 16.3378 22.2857H7.66224C7.35906 22.2857 7.08505 22.1086 6.96562 21.8355L5.2405 17.89C4.31502 17.7135 3.10088 17.2594 2.07045 16.3883C0.910009 15.4073 0 13.9092 0 11.7617C0 9.1821 0.81577 6.26734 2.71823 3.97662C4.63656 1.66679 7.62634 0.0340352 11.8646 2.07372e-05L11.8698 0ZM11.8724 1.23812C7.99834 1.26986 5.36981 2.74508 3.69784 4.75827C2.00963 6.79101 1.26316 9.41498 1.26316 11.7617C1.26316 13.5216 1.99127 14.6864 2.89541 15.4507C3.82003 16.2323 4.94627 16.6063 5.70203 16.711C5.96653 16.7477 6.18922 16.9167 6.29326 17.1546L7.99541 21.0476H16.0046L17.7067 17.1546C17.8108 16.9167 18.0335 16.7477 18.298 16.711C19.0537 16.6063 20.18 16.2323 21.1046 15.4507C22.0087 14.6864 22.7368 13.5216 22.7368 11.7617C22.7368 9.41498 21.9904 6.79101 20.3022 4.75827C18.6302 2.74508 16.0017 1.26986 12.1276 1.23812H11.8724Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47368 10.9997C9.47368 12.3673 8.34261 13.4759 6.94737 13.4759C5.55212 13.4759 4.42105 12.3673 4.42105 10.9997C4.42105 9.6321 5.55212 8.52345 6.94737 8.52345C8.34261 8.52345 9.47368 9.6321 9.47368 10.9997Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5789 10.9997C19.5789 12.3673 18.4479 13.4759 17.0526 13.4759C15.6574 13.4759 14.5263 12.3673 14.5263 10.9997C14.5263 9.6321 15.6574 8.52345 17.0526 8.52345C18.4479 8.52345 19.5789 9.6321 19.5789 10.9997Z",
    fill: "#FA1D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2632 14.095C13.2632 15.1207 12.6976 15.9522 12 15.9522C11.3024 15.9522 10.7368 15.1207 10.7368 14.095C10.7368 13.0693 11.3024 12.2378 12 12.2378C12.6976 12.2378 13.2632 13.0693 13.2632 14.095Z",
    fill: "#FA1D4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabSlasherTitle);
export default __webpack_public_path__ + "static/media/tabSlasherTitle.b16452ca406e0b1df3c3ec100b5d112a.svg";
export { ForwardRef as ReactComponent };